import { AppShell, type NavEntry } from '@cyntox/common/AppShell';
import { DataCoverageBar } from './ui';
import { useApp } from '../state/AppContext';

// The frame (sidebar, drawer, footer, version, help, links to the other apps)
// is shared by every Cyntox site. This is Admin's menu: what is shared across
// the apps, and the loading of the data they all read.

const NAV: NavEntry[] = [
  { to: '/import', label: 'Data Import', resource: 'dataImport' },
  { to: '/employees', label: 'Employees', resource: 'employees' },
  { to: '/schedules', label: 'Employee Schedules', resource: 'schedules' },
  { to: '/facilities', label: 'Facilities', resource: 'reference' },
  { to: '/paycodes', label: 'Pay Codes', resource: 'reference' },
  { to: '/admin', label: 'Administration', resource: 'users' },
  // Last, and on its own capability rather than users: audit access can be
  // granted without granting Administration.
  { to: '/audit', label: 'Audit Log', resource: 'audit' },
];

export function Shell() {
  const { reference, coverage } = useApp();

  return (
    <AppShell
      app="admin"
      badge="ADMIN"
      nav={NAV}
      version={__APP_VERSION__}
      helpLabel="How to use Admin"
      noLocationLabel="No locations"
      locationName={(code) => reference.facilities.find((f) => f.code === code)?.name ?? code}
      banner={<DataCoverageBar coverage={coverage} />}
    />
  );
}
